// extracted by mini-css-extract-plugin
export default {"caption":"Caption_caption__2LcR7","text01":"Caption_text01__7AIUm","text03":"Caption_text03__1923f","error":"Caption_error__1NYZp"};